// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/supporting-detail-card/supporting-detail-card.component.scss
// module id = 522
// module chunks = 0